import React, { Component } from "react";
import { Modal, Dropdown, InputGroup, FormControl, Badge } from "react-bootstrap";
import Pagination from "react-js-pagination";
import SearchSharpIcon from "@material-ui/icons/SearchSharp";
import { PiFileArrowDown } from "react-icons/pi";
import axios from "../../../axios";
import apiError from "../../../error";
import simulationandtrain from "../../../assets/create_campaign/simulationandtrain.png";
import { getUserActivityStatusBadgeProps } from "../user-activity-status-badge";
import ActivityDrawer from "../activity-drawer";
import "./by-template.css";

export default class ByTemplateModal extends Component {
    state = {
        search: "",
        activePage: 1,
        limit: 10,
        results: [],
        count: 0,
        loading: true,
        activityDrawerOpen: false,
        activityDrawerUser: null,
    };

    componentDidUpdate(prevProps) {
        const { show, template } = this.props;
        if (show && (!prevProps.show || prevProps.template?.campaignTemplateId !== template?.campaignTemplateId)) {
            this.setState({ search: "", activePage: 1, limit: 10 }, this.load);
        }
    }

    load = () => {
        const { campaignId, simulationId, template } = this.props;
        this.setState({ loading: true });
        axios
            .get("/api/results", {
                params: {
                    limit: this.state.limit,
                    search: this.state.search,
                    page: this.state.activePage,
                    campaignId,
                    simulationId,
                    campaignTemplateId: template?.campaignTemplateId,
                },
            })
            .then((res) => {
                this.setState({
                    loading: false,
                    count: res.data.count,
                    results: res.data.results || [],
                });
            })
            .catch((error) => {
                this.setState({ loading: false, results: [], count: 0 });
                apiError(error);
            });
    };

    handleExportCsv = () => {
        const { campaignId, simulationId, template } = this.props;
        axios
            .get("/api/results/template/csv", {
                params: {
                    campaignId,
                    simulationId,
                    campaignTemplateId: template?.campaignTemplateId,
                },
                responseType: "blob",
            })
            .then((res) => {
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", `${template?.name || "template"}.csv`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })
            .catch((err) => {
                apiError(err);
            });
    };

    /* Simulation + Training export, scoped to this template's users */
    handleExportSimulationTrainingCsv = () => {
        const { campaignId, simulationId, template } = this.props;
        axios
            .get("/api/results/template/simulationtraining/csv", {
                params: {
                    campaignId,
                    simulationId,
                    campaignTemplateId: template?.campaignTemplateId,
                },
                responseType: "blob",
            })
            .then((res) => {
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", `${template?.name || "template"}-simulation-training.csv`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })
            .catch((err) => {
                apiError(err);
            });
    };

    handleExportEventCsv = () => {
        const { campaignId, simulationId, template } = this.props;
        axios
            .get("/api/results/template/eventcsv", {
                params: {
                    /* no `search` here — the endpoint exports the whole template scope and
                       rejects unknown query params */
                    campaignId,
                    simulationId,
                    campaignTemplateId: template?.campaignTemplateId,
                    tzOffset: new Date().getTimezoneOffset(),
                },
                responseType: "blob",
            })
            .then((res) => {
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", `${template?.name || "template"}-event.csv`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })
            .catch((err) => {
                apiError(err);
            });
    };

    renderUserActivityStatusBadge = (status) => {
        const { label, className } = getUserActivityStatusBadgeProps(status);
        return <Badge className={className}>{label}</Badge>;
    };

    render() {
        const { show, onClose, template } = this.props;
        const ct = template || {};
        const imgSrc = ct.thumbnailUrl ? ct.thumbnailUrl : simulationandtrain;
        const { results, count, activePage, limit, loading } = this.state;

        return (
            <>
                <Modal
                    className="info-filter right mainfooterModal right-modal-wrap by-template-modal"
                    show={show}
                    onHide={onClose}
                    autoFocus
                    keyboard
                >
                    <Modal.Header closeButton className="by-template-modal-header">
                        <div className=" d-flex align-items-center">
                            <img
                                className="by-template-modal-thumb"
                                src={imgSrc}
                                alt={ct.name}
                                onError={(e) => { e.target.onerror = null; e.target.src = simulationandtrain; }}
                            />
                            <div className="ml-3">
                                <div className="by-template-modal-name">{ct.name}</div>
                                <small className="by-template-modal-total text-muted">Total Users: {count}</small>
                            </div>
                        </div>
                    </Modal.Header>
                    <Modal.Body className="by-template-modal-body">
                        <div className=" filter-without-border">
                            <div className="align-items-center row">
                                <div className="col-md-7">
                                    <div className="positionSearchIcon">
                                        <InputGroup className="search-wrap">
                                            <FormControl
                                                type="text"
                                                placeholder="Search"
                                                value={this.state.search}
                                                onChange={(e) => this.setState({ search: e.target.value, activePage: 1 }, () => this.load())}
                                                className="inputSearch mr-sm-2 form-control"
                                            />
                                            <SearchSharpIcon className="search-icon" />
                                        </InputGroup>
                                    </div>
                                </div>
                                <div className="col-md-5">
                                    <div className="rightFilters">
                                    <Dropdown className="d-inline-block">
                                        <Dropdown.Toggle variant="secondary" id="by-template-export-dropdown" className="dropdown-color-white">
                                            <PiFileArrowDown className="mr-1" />
                                            Export
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <Dropdown.Item onClick={this.handleExportCsv}>Simulation (.csv)</Dropdown.Item>
                                            {this.props.simulationType !== "Simulation Attack" && (
                                                <Dropdown.Item onClick={this.handleExportSimulationTrainingCsv}>
                                                    Simulation + Training (.csv)
                                                </Dropdown.Item>
                                            )}
                                            <Dropdown.Item onClick={this.handleExportEventCsv}>Event Logs (.csv)</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                    </div>
                                </div>
                            </div>



                        </div>

                        <div className="table-container-wrapper">
                            <table className="table by-template-modal-table">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Designation</th>
                                        <th>Department</th>
                                        <th>Location</th>
                                        <th>Last Activity</th>
                                        <th>EVS</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {results.length ? results.map((result) => {
                                        const target = result && result.target ? result.target : {};
                                        const first = (target.firstname || "").trim();
                                        const last = (target.lastname || "").trim();
                                        const initials = (first.charAt(0) + (last ? last.charAt(0) : first.charAt(1) || "")).toUpperCase() || "—";
                                        const displayName = [first, last].filter(Boolean).join(" ") || "—";
                                        const isPlaceholder = target.firstname === "_";
                                        return (
                                            <tr key={result.id || result.email} style={isPlaceholder ? { opacity: 0.5 } : {}}>
                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        <div className="user-initials-avatar">{initials}</div>
                                                        <div className="ml-2">
                                                            <div className="user-name-text">{displayName}</div>
                                                            <small className="user-email-text text-muted">{target.email || "—"}</small>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>{target.position || "—"}</td>
                                                <td>{target.department && target.department.name ? target.department.name : "—"}</td>
                                                <td>{target.location && target.location.name ? target.location.name : "—"}</td>
                                                <td>{this.renderUserActivityStatusBadge(result.status)}</td>
                                                <td>{(result.evsScore !== null && result.evsScore !== undefined) ? result.evsScore : "—"}</td>
                                                <td>
                                                    {!isPlaceholder && (
                                                        <a href="#" className="view-link" onClick={(e) => { e.preventDefault(); this.setState({ activityDrawerOpen: true, activityDrawerUser: result }); }}>View</a>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    }) : (
                                        <tr>
                                            <td colSpan={7} className="text-center text-muted py-4">{loading ? "Loading…" : "No data found"}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>

                            {!loading && count > 0 && (
                                <div className="pagination-Wrap" style={{border:"none"}}>
                                <div className="row align-items-center">
                                    <div className="col-md-6">
                                        <Pagination
                                            itemClass="page-item"
                                            linkClass="page-link"
                                            activePage={activePage}
                                            itemsCountPerPage={limit}
                                            totalItemsCount={count}
                                            onChange={(pageNumber) => this.setState({ activePage: pageNumber }, () => this.load())}
                                        />
                                    </div>
                                    <div className="col-md-6 text-right d-flex align-items-center footer-pg" style={{position:"absolute", right:"10px"}}>
                                        <div className="w-100 pgCount">
                                            <p>
                                                {`${(activePage - 1) * limit + 1}-${Math.min(activePage * limit, count)} of ${count} records`}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            )}
                        </div>

                        
                    </Modal.Body>
                </Modal>
                <ActivityDrawer
                    show={this.state.activityDrawerOpen}
                    onClose={() => this.setState({ activityDrawerOpen: false, activityDrawerUser: null })}
                    user={this.state.activityDrawerUser}
                    attackType={this.props.attackType}
                />
            </>
        );
    }
}
